import Button from "@mui/material/Button";
import React from "react";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export const OutOfTownURI = "/where-to-dance/out-of-town"
export const OutOfTownButton = (props) => <Button {...props} size={"small"} startIcon={<CalendarMonthIcon size={"small"} />} href={OutOfTownURI}><span style={{fontSize: "80%"}}>Out Of Town</span></Button>